// For more information: https://github.com/biati-digital/glightbox

import GLightbox from 'glightbox';
import {each, includes} from 'lodash';

const loaded = [];

const getMimeType = (url) => {
    return new Promise(function (resolve) {
        const xhr = new XMLHttpRequest();
        xhr.open('HEAD', url);
        xhr.onreadystatechange = function () {
            if (this.readyState === this.DONE) {
                resolve(this.getResponseHeader('Content-Type'));
            }
        };
        xhr.send();
    });
};

const initGLightbox = () => {
    new GLightbox();

    each(document.querySelectorAll('[data-lightbox]'), (element) => {
        // Prevent multiple executions
        if (includes(loaded, element)) {
            return;
        }
        loaded.push(element);
        element.addEventListener('click', function (e) {
            e.preventDefault();
            const url = this.getAttribute('href');
            getMimeType(url).then((mimeType) => {
                const isAudio = mimeType.startsWith('audio/');
                const lightbox = GLightbox({
                    skin: isAudio ? 'clean audio' : 'clean',
                    elements: [
                        isAudio
                            ? {
                                content: '<audio class="w-100" controls autoplay><source src="'
                                    + url + '"/></audio>',
                                height: 'auto'
                            }
                            : {href: url}
                    ],
                    zoomable: false,
                    draggable: false
                });
                lightbox.open();
            });
        });
    });
};

export default class GLightBox {

    static init() {
        initGLightbox();
        document.addEventListener('livewire:load', () => {
            window.livewire.hook('message.processed', () => {
                initGLightbox();
            });
        });
    }

}
